export default __webpack_public_path__ + "static/quadrant-text-regular-italic-f7d3345cee8607bf92ec376e45d41b8e.woff";